<section class="blog-index">
  @if (hasPosts()) {
    <!-- Pinned front-door block — the blog's real job. Question cards, not
         the library's card treatment: no image, the post title set as the
         question, the excerpt as a one-line answer, a "Read more" text
         link — so the front door reads as answers, not as more library. -->
    <section class="blog-front-door" aria-labelledby="front-door-heading">
      <app-section-head
        kicker="Thinking about lessons?"
        heading="Start here"
        headingId="front-door-heading"
      />
      <p class="blog-front-door-lede">
        Cost, how it compares to other ways to learn, and what to expect before
        you book a lesson.
      </p>
      <ul
        class="blog-front-door-list"
        role="list"
        aria-label="Posts for prospective students"
      >
        @for (post of frontDoorPosts(); track post.slug) {
          <li>
            <article
              class="blog-question-card"
              grooveSurface
              variant="bordered"
            >
              <h3 class="blog-question-card-title groove-type-heading">
                <a [routerLink]="['/blog', post.slug]">{{ post.title }}</a>
              </h3>
              <p class="blog-question-card-answer">{{ post.excerpt }}</p>
              <a
                class="blog-question-card-link groove-text-link"
                [routerLink]="['/blog', post.slug]"
              >
                Read more&nbsp;&rarr;
              </a>
            </article>
          </li>
        }
      </ul>
    </section>

    <hr class="section-divider" />

    <!-- The library: one column, one section per category
         (LIBRARY_CATEGORY_ORDER), each with a one-line description, the first
         five posts as a plain link list, and an "All N … posts →" link to the
         /blog/topic/<category> page for the rest. No separate lede: the
         heading below already says what the library is. -->
    <section class="blog-library" aria-labelledby="library-heading">
      <app-section-head
        kicker="The library"
        heading="Everything else Russ has written about playing bass"
        headingId="library-heading"
      />
      @for (group of libraryGroups(); track group.category) {
        <section
          class="blog-library-group"
          [attr.aria-labelledby]="'library-group-' + group.category"
        >
          <h3
            class="blog-library-group-heading"
            [id]="'library-group-' + group.category"
          >
            {{ group.label }}
          </h3>
          <p class="blog-library-group-description">{{ group.description }}</p>
          <ul class="blog-library-list" role="list">
            @for (post of group.posts; track post.slug) {
              <li>
                <a [routerLink]="['/blog', post.slug]">{{ post.title }}</a>
              </li>
            }
          </ul>
          <a
            class="blog-library-group-all groove-text-link groove-ring"
            data-tone="accent"
            [routerLink]="['/blog/topic', group.category]"
          >
            All {{ group.totalCount }} {{ group.label }} posts&nbsp;&rarr;
          </a>
        </section>
      }
    </section>
  } @else {
    <p class="blog-index-empty">
      No posts yet — check back soon, or
      <a routerLink="/"> learn about online bass lessons with Russ </a>
      in the meantime.
    </p>
  }
</section>

<app-page-cta location="bottom" />
